import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import { watchOnce } from '@vueuse/core'
import User from '@/models/user'
import Job from '@/models/job'
import { submitJobForApprovalMutation } from '@/api/jobs'
import FormLayout from '@/components/common/FormLayout.vue'
import VsForm from '@/components/vision/VsForm.vue'
import VsAutocomplete from '@/components/vision/Inputs/VsAutocomplete/VsAutocomplete.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import VsText from '@/components/vision/VsText.vue'
import JobNewGuestUserForm from '@/components/jobs/JobNewGuestUserForm.vue'
import VsBottomSheet from '@/components/vision/VsBottomSheet.vue'
import { useHubs } from '@/common/useHubs'
import { useBusinessUnitPermissions } from '@/components/tickets/common/useBusinessUnitPermissions'
import validateEmail from '@/utils/email-validation'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'SendForApprovalBottomSheet',
  props: {
    job: null
  },
  emits: ['submitted-for-approval'],
  setup(__props: any, { emit }) {

const props = __props as {
  job: Job
}



const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

const {
  mutateAsync: submitForApproval,
  isLoading,
  error: submitForApprovalError,
} = submitJobForApprovalMutation()
const showBottomSheet = ref(false)
const autocompleteComponent = ref()
const sendForApprovalForm = ref()
const formData = ref<string[]>([])
const store = useStore()
const getUsersRelatedToBusinessUnit = computed<
  (buId: string | undefined) => User[]
>(() => store.getters['users/getUsersRelatedToBusinessUnit'])
const getUserBySid = computed<(userSid: string) => User>(
  () => store.getters['users/getBySid']
)
const { canCreateNewGuestRequester } = useBusinessUnitPermissions()
const requester = computed(() => getUserBySid.value(props.job.customerSid))
const isSnackbarVisible = ref(false)
const snackbarError = ref()
watchOnce(
  requester,
  (newVal) => {
    formData.value.push(newVal.email)
  },
  { immediate: true }
)

const { currentHub } = useHubs()
const items = computed(() =>
  getUsersRelatedToBusinessUnit.value(currentHub.value?.id).map((u) => ({
    text: u.name,
    value: u.email,
  }))
)


function dismiss() {
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isSendingEmailForApprovalBottomSheetVisible: false,
  })
}

const updateFormData = (e: string[] | null | undefined) => {
  if (e) {
    formData.value = e.filter(Boolean)
  }
}
const save = async () => {
  try {
    if (!sendForApprovalForm.value.isValid()) {
      return
    }
    if (formData.value.length === 0) {
      snackbarError.value = 'You must choose at least one user'
      isSnackbarVisible.value = true
      return
    }
    const sanitizedEmails = formData.value.filter((email) =>
      validateEmail(email)
    )
    await submitForApproval({ uuid: props.job.uuid, emails: sanitizedEmails })
    emit('submitted-for-approval')
    dismiss()
  } catch (error) {
    snackbarError.value = submitForApprovalError.value
    isSnackbarVisible.value = true
  }
}
const localSearchValue = ref()
const handleCreateGuestRequesterClick = (
  currentSearchValue?: string | null
) => {
  localSearchValue.value = currentSearchValue
  showBottomSheet.value = true
  autocompleteComponent.value.close()
}

return { __sfc: true,props, jobBottomSheetStatesStore, submitForApproval, isLoading, submitForApprovalError, showBottomSheet, autocompleteComponent, sendForApprovalForm, formData, store, getUsersRelatedToBusinessUnit, getUserBySid, canCreateNewGuestRequester, requester, isSnackbarVisible, snackbarError, currentHub, items, emit, dismiss, updateFormData, save, localSearchValue, handleCreateGuestRequesterClick, FormLayout, VsForm, VsAutocomplete, VsSnackbar, VsText, JobNewGuestUserForm, VsBottomSheet }
}

})